import { authService } from '../services/authService';

export const getRequestConfig = () => {
  const accessToken = authService.getAccessToken();
  return accessToken ? {
    headers: {
      'Authorization': `Bearer ${accessToken}`
    }
  } : {};
};

export const getAuthHeaders = () => {
  const accessToken = authService.getAccessToken();
  return accessToken ? {
    'Authorization': `Bearer ${accessToken}`
  } : {};
};
